import {
  DEFAULT_DESCRIPTION,
  buildCanonical,
  buildPageTitle,
} from "./constants";
import type { PageSeo, StaticPageSeoEntry } from "./types";

export const STATIC_PAGE_SEO: Record<string, StaticPageSeoEntry> = {
  "/": {
    description: DEFAULT_DESCRIPTION,
  },
  "/about/": {
    pageTitle: "Balanced Bodyとは",
    description:
      "Balanced Body社の歴史と、世界65カ国以上で認められるインストラクター資格についてご紹介します。米国本部認定のAuthorized Training Centerとして養成講座を開講しています。",
  },
  "/schedule/": {
    pageTitle: "開講スケジュール",
    description:
      "Balanced Bodyピラティスインストラクター養成講座の開講スケジュール一覧です。マット、リフォーマー、AI3D解剖学、動きの原則など各コースの直近日程をご確認いただけます。",
  },
  "/courses/": {
    pageTitle: "講座一覧",
    description:
      "Balanced Bodyピラティスインストラクター養成講座の各コース（マット、リフォーマー、AI3D解剖学、動きの原則）の内容をご紹介します。",
  },
  "/courses/mat/": {
    pageTitle: "マットインストラクター養成コース",
    description:
      "ピラティスの土台となるマットエクササイズを80種類以上学ぶBalanced Bodyマットインストラクター養成コースの内容・受講条件・開催地をご紹介します。",
  },
  "/courses/reformer/": {
    pageTitle: "リフォーマーインストラクター養成コース",
    description:
      "リハビリからアスリートトレーニングまで幅広く対応できるリフォーマーマシンを学ぶBalanced Bodyリフォーマーインストラクター養成コースの内容をご紹介します。",
  },
  "/courses/ai3d/": {
    pageTitle: "AI3D解剖学講座",
    description:
      "ミニ骨格模型と粘土を使い、骨と筋肉の仕組みを楽しく学ぶAI3D解剖学講座。Balanced Bodyインストラクター養成に必要な解剖学知識を習得できます。",
  },
  "/courses/movement-principles/": {
    pageTitle: "動きの原則",
    description:
      "トレーニングの土台となる基本的な体の動きのパターンを理解し、正しく指導する方法を学ぶBalanced Body「動きの原則」講座の内容をご紹介します。",
  },
  "/prices/": {
    pageTitle: "費用",
    description:
      "Balanced Bodyピラティスインストラクター養成講座の費用案内です。各コースの単科受講と、インストラクター養成一括コースからお選びいただけます。",
  },
  "/prices/single/": {
    pageTitle: "単科受講費用",
    description:
      "Balanced Body養成講座を単科で受講する場合の費用一覧です。動きの原則、マット、リフォーマー、AI3D解剖学など各講座の受講料をご確認いただけます。",
  },
  "/prices/set/": {
    pageTitle: "インストラクター養成一括コース",
    description:
      "Balanced Body認定インストラクターを目指す方向けのお得なセットプランです。開講している講座の組み合わせ毎に一括受講料金をご用意しています。",
  },
  "/entry/": {
    pageTitle: "受講を申し込む",
    description:
      "Balanced Bodyピラティスインストラクター養成講座の受講申込フォームです。対面・オンライン受講に対応しています。",
  },
  "/entry/thanks/": {
    pageTitle: "受講申込完了",
    description: "Balanced Body養成講座の受講申込を受け付けました。",
    noindex: true,
  },
  "/contact/": {
    pageTitle: "質問や無料相談はこちら",
    description:
      "Balanced Bodyピラティスインストラクター養成講座に関するお問い合わせ・無料相談はこちらから。受講に関するご質問をお気軽にどうぞ。",
  },
  "/goods-order/": {
    pageTitle: "BBツール注文フォーム",
    description:
      "Balanced Body養成講座 受講生向けのBBオフィシャル商品注文フォームです。",
    noindex: true,
  },
  "/goods-order/thanks/": {
    pageTitle: "ご注文受付完了",
    description: "BBツールのご注文を受け付けました。",
    noindex: true,
  },
  "/contact/thanks/": {
    pageTitle: "お問い合わせ完了",
    description: "Balanced Body養成講座へのお問い合わせを受け付けました。",
    noindex: true,
  },
  "/thanks/": {
    pageTitle: "送信完了",
    description: "フォームの送信を受け付けました。",
    noindex: true,
  },
  "/faq/": {
    pageTitle: "よくあるご質問",
    description:
      "Balanced Body養成講座に関するよくあるご質問一覧です。資格取得までの流れ、お支払い、テストアウトなどについてまとめています。",
  },
  "/news/": {
    pageTitle: "お知らせ",
    description:
      "Balanced Bodyピラティスインストラクター養成講座に関するお知らせ・最新情報一覧です。",
  },
  "/news/preview/": {
    pageTitle: "お知らせプレビュー",
    description: "お知らせのプレビューページです。",
    noindex: true,
  },
  "/studios/": {
    pageTitle: "スタジオ一覧",
    description:
      "Balanced Body養成講座の開講スタジオ一覧です。各スタジオのアクセス情報や開講スケジュールへのリンクをご確認いただけます。",
  },
  "/studios/preview/": {
    pageTitle: "スタジオプレビュー",
    description: "スタジオ情報のプレビューページです。",
    noindex: true,
  },
  "/master-instructor/": {
    pageTitle: "講師紹介",
    description:
      "Balanced Bodyプリンシパル・エディケーター萩野佳央理のプロフィールと、養成講座担当講師としてのメッセージをご紹介します。",
  },
  "/master-instructor/preview/": {
    pageTitle: "講師紹介プレビュー",
    description: "講師紹介のプレビューページです。",
    noindex: true,
  },
  "/followup/": {
    pageTitle: "フォローアップ",
    description:
      "Balanced Body養成講座受講中・資格取得後のフォローアップ制度をご紹介します。質問対応、復習動画、テストアウト対策講座など充実したサポート体制です。",
  },
  "/otherschools/": {
    pageTitle: "ブリッジ制度",
    description:
      "他の流派・団体の方でBalanced Body認定資格に興味のある方向けのブリッジ制度についてご説明します。",
  },
  "/feedback/": {
    pageTitle: "受講生の声",
    description:
      "Balanced Bodyピラティスインストラクター養成講座を受講された方の声をご紹介します。",
  },
  "/access/": {
    pageTitle: "受講会場",
    description: "Balanced Body養成講座の受講会場・アクセス情報です。",
  },
  "/terms/": {
    pageTitle: "申込規約",
    description:
      "Balanced Bodyピラティスインストラクター養成講座の受講申込規約です。",
  },
  "/tradelaw/": {
    pageTitle: "特定商取引法に基づく表記",
    description: "Balanced Body養成講座に関する特定商取引法に基づく表記です。",
  },
  "/sitemap/": {
    pageTitle: "サイトマップ",
    description:
      "Balanced Bodyピラティスインストラクター養成講座サイトのサイトマップです。",
  },
  "/draft/": {
    pageTitle: "下書きプレビュー",
    description: "コンテンツの下書きプレビューページです。",
    noindex: true,
  },
  "/sentry-example/": {
    pageTitle: "Sentry Example",
    description: "Sentry test page.",
    noindex: true,
  },
};

export function getStaticPageSeo(pathname: string): PageSeo | undefined {
  const entry = STATIC_PAGE_SEO[pathname];
  if (!entry) return undefined;

  return {
    title: buildPageTitle(entry.pageTitle),
    description: entry.description,
    canonical: buildCanonical(pathname),
    noindex: entry.noindex,
  };
}

export function getIndexableStaticPaths(): string[] {
  return Object.entries(STATIC_PAGE_SEO)
    .filter(([, entry]) => !entry.noindex)
    .map(([path]) => path);
}
